
webpack.register(
    'components/modal-dialog/modal-dialog',
    function() {
        return require('components/modal-dialog/modal-dialog');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/modal-dialog/modal-dialog'/>\r\n\r\n<button class=\"c-information-modal js-info-modal\" data-analytics-track=\"true\" data-analytics-projected-cutline=\"true\">\r\n    <div class=\"s-info\">\r\n        <modal-dialog small-full-screen>\r\n            <div class=\"s-info\"><span class=\"s-info-icon\"></span>{{title}}</div>\r\n            <div class=\"s-text\">\r\n                <content/>\r\n            </div>\r\n        </modal-dialog>\r\n    </div>\r\n</button>");